export const URL = "https://graphql.anilist.co";
export const SEARCH_QUERY = `
  query ($page: Int, $perPage: Int, $search: String) {
    Page (page: $page, perPage: $perPage) {
      pageInfo {
        total
        currentPage
        lastPage
        hasNextPage
        perPage
      }
      media (search: $search, type: MANGA) {
        anilist_id: id
        name_english: title {
          english
        }
        name_romaji: title {
          romaji
        }
        image_url: coverImage {
          extraLarge
        }
      }
    }
  }`;
export const CAMPAIGN_QUERY = `
  query($id: Int) {
    Media(id: $id) {
      id
      title {
        romaji
        english
      }
      description
      coverImage {
        extraLarge
      }
      externalLinks {
        id
        icon
        url
        color
      }
      bannerImage
      relations {
        edges {
          relationType
          node {
            title {
              english
              romaji
            }
            type

          }
        }
      }
      recommendations {
        edges {
          node {
            mediaRecommendation {
              id
              title {
                romaji
                english
              }
              coverImage {
                extraLarge
              }
            }
          }
        }
      }
    }
  }`;
export const RECOMMENDATION_QUERY = `
  query ($page: Int, $perPage: Int, $search: Int) {
    Page(page: $page, perPage: $perPage) {
      pageInfo {
        total
        currentPage
        lastPage
        hasNextPage
        perPage
      }
      recommendations(mediaId: $search) {
        mediaRecommendation {
          id
          title {
            romaji
            english
          }
          type
          coverImage {
            extraLarge
          }
          relations {
            edges {
              id
              relationType
              node {
                title {
                  english
                  romaji
                }
                type
              }
            }
          }
        }
      }
    }
  }`;
